import { createAction } from '@reduxjs/toolkit'

export const ALERTS_LOAD = 'ALERTS_LOAD'

export const alertsLoad = createAction(ALERTS_LOAD)
